import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export function CheckList({ items, value = [], onChange, labelKey = "name", subKey, className, testId, emptyText = "Nothing to choose from" }) {
  const toggle = (id, on) => onChange(on ? [...value, id] : value.filter((x) => x !== id));
  return (
    <div className={cn("max-h-48 divide-y divide-border overflow-auto border border-border", className)} data-testid={testId}>
      {items.length === 0 && <div className="p-3 text-xs text-muted-foreground">{emptyText}</div>}
      {items.map((it) => (
        <label key={it.id} className="row-hover flex cursor-pointer items-center gap-3 px-3 py-1.5">
          <Checkbox checked={value.includes(it.id)} onCheckedChange={(v) => toggle(it.id, !!v)} data-testid={testId ? `${testId}-${it.id}` : undefined} />
          <span className="min-w-0 flex-1 truncate text-sm">{it[labelKey]}</span>
          {subKey && it[subKey] && <span className="mono truncate text-[11px] text-muted-foreground">{it[subKey]}</span>}
        </label>
      ))}
    </div>
  );
}

export function EmailList({ value = [], onChange, placeholder = "sales@company.com, ops@company.com", testId }) {
  return (
    <Input value={value.join(", ")} onChange={(e) => onChange(e.target.value.split(/[,;\s]+/).filter(Boolean))} placeholder={placeholder} className="mono text-xs" data-testid={testId} />
  );
}
